// Global object for YouTube players.
var youtubePlayers = {};

// YouTube IFrame API ready callback
window.onYouTubeIframeAPIReady = function() {
  document.querySelectorAll('.youtube-iframe').forEach(function(iframe, i) {
    if (!iframe.id) iframe.id = 'youtube-player-' + i;
    youtubePlayers[iframe.id] = new YT.Player(iframe.id);
  });
};

// Wait for content
function waitForBadOwlContainer() {
  if (document.querySelector('.accordion')) {
    initializeSwipers();
    setupAccordionDelegation();
  } else {
    setTimeout(waitForBadOwlContainer, 100);
  }
}
document.addEventListener('DOMContentLoaded', waitForBadOwlContainer);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load',   () => setTimeout(waitForBadOwlContainer, 200));
  document.addEventListener('shopify:section:select', () => setTimeout(waitForBadOwlContainer, 200));
}

// Initialize all swipers
function initializeSwipers() {
  document.querySelectorAll('[class*="swiper-main-cat-"]').forEach(function(el) {
    if (!el.swiper) {
      el.classList.add(
        el.querySelectorAll('.swiper-slide').length === 1 ? 'single-video' : 'multiple-videos'
      );
      initSwiper(el);
    }
  });
}

// Setup a swiper with tap & pause logic
function initSwiper(el) {
  new Swiper(el, {
    effect: 'coverflow',
    grabCursor: true,
    simulateTouch: true,
    allowTouchMove: true,
    touchEventsTarget: 'container',
    centeredSlides: true,
    loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
    navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
    on: {
      init: function(swiper) { pauseInactive(swiper); },
      slideChangeTransitionEnd: function(swiper) { pauseInactive(swiper); },
      tap: function(swiper) {
        var iframe = swiper.slides[swiper.activeIndex].querySelector('.youtube-iframe');
        if (iframe && iframe.id && youtubePlayers[iframe.id]) {
          youtubePlayers[iframe.id].playVideo();
        }
      }
    }
  });
}

// Pause non-active slides
function pauseInactive(swiper) {
  swiper.slides.forEach(function(slide) {
    var iframe = slide.querySelector('.youtube-iframe');
    if (iframe && iframe.id && youtubePlayers[iframe.id] && !slide.classList.contains('swiper-slide-active')) {
      youtubePlayers[iframe.id].pauseVideo();
    }
  });
}

// Accordion toggle
function setupAccordionDelegation() {
  $(document).off('click touchstart', '.accordion-header');
  $(document).on('click touchstart', '.accordion-header', function(e) {
    e.preventDefault();
    var $h = $(this);
    if (e.type === 'click' && $h.data('justTouched')) { $h.removeData('justTouched'); return; }
    if (e.type === 'touchstart') { $h.data('justTouched', true); }

    var $item = $h.closest('.accordion-item');
    $('.accordion-item.open').not($item).removeClass('open');
    $item.toggleClass('open');

    if ($item.hasClass('open')) initializeSwipers();
    return false;
  });
}

$(document).ready(setupAccordionDelegation);